/**
 * @generated SignedSource<<fe54bfef14f7abb867e0ed0344d50284>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateChannelPayload",
    "kind": "LinkedField",
    "name": "updateChannel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OwnedChannel",
        "kind": "LinkedField",
        "name": "channel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "callbackUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "callbackQuery",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateChannelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateChannelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "687bb345d8255fe1ad279f7b123dd32d",
    "id": null,
    "metadata": {},
    "name": "UpdateChannelMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateChannelMutation(\n  $input: UpdateChannelInput!\n) {\n  updateChannel(input: $input) {\n    channel {\n      id\n      callbackUrl\n      callbackQuery\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b387ca6e77b9368ead9579126b5111b5";

export default node;
